import { Package, Flame, Star, ArrowRight } from "lucide-react";

export default function AppRow({ app, selected, hot, fav, onSelect, onToggleFav }) {
  const price = app.price != null ? Number(app.price).toLocaleString("pt-BR", { minimumFractionDigits: 2 }) : null;
  return (
    <button
      onClick={() => onSelect(app)}
      data-testid={`app-row-${app.id}`}
      className={`group relative flex w-full items-center gap-3 border-b border-l-2 border-border px-3 py-3 text-left transition-colors ${
        selected ? "border-l-primary bg-primary/10" : "border-l-transparent hover:bg-muted/60"
      }`}
    >
      <span
        onClick={(e) => { e.stopPropagation(); onToggleFav(app.id); }}
        role="button"
        aria-label="Favoritar"
        data-testid={`fav-${app.id}`}
        className={`shrink-0 ${fav ? "text-primary" : "text-muted-foreground/40 hover:text-primary"}`}
      >
        <Star className={`h-4 w-4 ${fav ? "fill-primary" : ""}`} />
      </span>

      <span className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-md border border-border bg-muted">
        {app.logo ? (
          <img
            src={app.logo}
            alt={app.name}
            className="h-full w-full object-cover transition-transform duration-200 group-hover:scale-105"
            onError={(e) => { e.target.style.display = "none"; e.target.parentElement.querySelector("[data-fb]").style.display = "flex"; }}
          />
        ) : null}
        <Package data-fb className="h-5 w-5 text-muted-foreground" style={{ display: app.logo ? "none" : "flex" }} />
      </span>

      <span className="min-w-0 flex-1">
        <span className="flex items-center gap-2">
          <span className="truncate font-heading text-sm font-semibold transition-transform duration-200 group-hover:translate-x-0.5">{app.name}</span>
          {hot && (
            <span className="inline-flex items-center gap-1 rounded-sm bg-primary/15 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-primary" data-testid={`hot-${app.id}`}>
              <Flame className="h-3 w-3" /> Em alta
            </span>
          )}
        </span>
        <span className="mt-0.5 block truncate text-[11px] uppercase tracking-widest text-muted-foreground">{app.category || "Player"}</span>
      </span>

      <span className="shrink-0 text-right">
        {price && <span className="block font-num text-sm font-bold">R$ {price}</span>}
        <span className="block text-[11px] text-muted-foreground">
          ou <span className="font-num text-foreground">{app.credit_cost}</span> cr.
        </span>
      </span>

      <ArrowRight className={`h-4 w-4 shrink-0 transition-all ${selected ? "text-primary opacity-100" : "text-muted-foreground opacity-0 -translate-x-1 group-hover:translate-x-0 group-hover:opacity-60"}`} />
    </button>
  );
}
